import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { Controller } from "react-hook-form";
import useLocales from "src/hooks/useLocales";

type Props = {
	control: any;
	name: string;
};

export default function BirthDateSelector({ control, name }: Props) {
	const { translate } = useLocales();
	return (
		<Controller
			control={control}
			name={name}
			render={({ field, fieldState: { error } }) => (
				<DatePicker
					disableFuture
					label={translate("Fecha de nacimiento")}
					maxDate={moment().add(-18, "years")}
					minDate={moment().add(-100, "years")}
					slotProps={{
						textField: {
							fullWidth: true,
							variant: "outlined",
							error: !!error,
							helperText: error?.message
						}
					}}
					{...field}
				/>
			)}
		/>
	);
}
